<template>
	<div class="partner-card-wrapper mt-2">
		<div class="partner-card">
			<router-link
				class="partner-card-wrapper__link"
				:to="{
					name: 'exhibitor-by-id',
					params: {
						id: partner.partner_id,
					},
					query: {
						group: this.$route.params.id,
						event: this.$route.query.event,
					},
				}"
				@click.native="handleClick"
			>
				<div class="partner-card__logo">
					<img :src="partner.partner_logo" alt="partnerLogo" loading="lazy" />
				</div>
				<div class="partner-card__info">
					<div class="partner-card__title">
						{{ partner.partner_name }}
					</div>
					<div
						v-if="partner.partner_location || partner.partner_location_title"
						class="partner-card__subtitle d-flex align-center mt-1"
					>
						<Icon type="pin" :size="16" color="var(--location-color)" />
						<span class="partner-card__location-value ml-1">{{
							partner.partner_location_title || partner.partner_location
						}}</span>
					</div>
				</div>
			</router-link>
			<div @click="bookmarksToggle" class="partner-card__bookmark">
				<Icon
					:type="followStatus ? 'bookmark' : 'bookmark_empty'"
					:size="24"
					:color="followStatus ? 'var(--text_button_tint)' : 'var(--accent-color)'"
					class="exhibitor-page__icon"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Dwh from '@/mixins/Dwh'
import { mapActions, mapGetters } from 'vuex'

Vue.use(VueScrollTo)

export default {
	name: 'PartnerCard',
	mixins: [Dwh],
	props: {
		partner: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			followStatus: this.partner.follow_status,
		}
	},
	computed: {
		...mapGetters('event', ['exhibitorFollow']),
	},
	methods: {
		...mapActions('event', ['followExhibitor']),
		handlerBookMark() {
			this.sendTrigger({
				category: 'Event',
				action: 'click_exhibitor_list_bookmark',
				module: 'Exhibitor Booth',
				data: this.partner.partner_id,
				title: this.partner.partner_name,
			})
		},
		bookmarksToggle() {
			const newStatus = this.followStatus ? 0 : 1
			if (newStatus === 1) {
				this.handlerBookMark()
			}
			this.followExhibitor({
				id: this.partner.partner_id,
				follow_status: newStatus,
			})
				.then(() => {
					this.followStatus = newStatus
				})
				.catch((e) => {
					console.error(e)
				})
		},
		handleClick() {
			this.sendTrigger({
				category: 'Content',
				action: 'click_exhibitor_profile_event',
				module: 'Events',
				data: this.partner.partner_id,
				title: this.partner.partner_name,
			})
		},
	},
}
</script>

<style lang="scss">
.partner-card-wrapper {
	display: flex;
	align-items: center;
	background: #ffffff;
	border: 1px solid #e2e2e2;
	border-radius: 8px;
	padding: 16px;
	cursor: pointer;
	text-decoration: none;

	&__link {
		display: flex;
		width: 100%;
		text-decoration: none;
	}

	.partner-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;

		&__location-value {
			font-family: Inter, sans-serif;
			font-weight: 500;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--location-color) !important;
		}

		&__logo {
			width: 64px;
			height: 64px;
			border-radius: 4px;
			overflow: hidden;
			margin-right: 16px;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}

		&__info {
			flex: 1;

			&__title {
				font-family: Inter, sans-serif;
				font-weight: 700;
				font-size: 16px;
				line-height: 100%;
				letter-spacing: 0;
				color: #002855;
				margin-bottom: 4px;
			}

			&__subtitle {
				display: flex;
				align-items: center;
				font-family: Inter, sans-serif;
				font-weight: 500;
				font-size: 13px;
				line-height: 100%;
				letter-spacing: 0;

				svg {
					margin-right: 8px;
				}
			}
		}

		&__bookmark {
			margin-left: 16px;
			cursor: pointer;

			svg {
				transition: transform 0.3s;
				margin-top: 4px;
			}

			&:hover svg {
				transform: scale(1.1);
			}
		}
	}
}
</style>
